import styles from "./FilterChips.module.css";

/** Toggle buttons for one filter. An option's optional `count` shows how many it matches. */
export default function FilterChips({ label, options, value, onChange }) {
  return (
    <div className={styles.group} role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={styles.chip}
          aria-pressed={value === o.value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
          {o.count !== undefined ? <span className={styles.count}>{o.count}</span> : null}
        </button>
      ))}
    </div>
  );
}
